(() => {
  const card = document.querySelector('.collector-invitation');
  const teaser = document.querySelector('.collector-invitation-teaser');
  if (!card || !teaser || location.pathname.startsWith('/cart')) return;
  const demo = new URLSearchParams(location.search).get('signup-preview') === '1';
  const form = card.querySelector('form');
  const status = card.querySelector('[data-signup-status]');
  const submit = form.querySelector('[type="submit"]');
  const label = submit.querySelector('[data-signup-label]');
  const phoneCountry = form.querySelector('[name="phoneCountry"]');
  const phoneInput = form.querySelector('[name="phone"]');
  if (window.KBCollectorPhone) {
    const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
    const countries = KBCollectorPhone.countries.map(({ country, code }) => ({ country, code, name: names.of(country) }));
    countries.sort((a, b) => a.name.localeCompare(b.name));
    phoneCountry.replaceChildren(...countries.map(({ country, code, name }) => new Option(`${name} (+${code})`, country)));
    phoneCountry.value = countries.some(({ country }) => country === phoneCountry.dataset.defaultCountry) ? phoneCountry.dataset.defaultCountry : 'US';
    const updateCode = () => {
      const selected = countries.find(({ country }) => country === phoneCountry.value);
      if (selected) form.querySelector('[data-phone-code]').textContent = `${selected.country} +${selected.code} ▾`;
      phoneInput.setCustomValidity('');
    };
    phoneCountry.addEventListener('change', updateCode);
    phoneInput.addEventListener('input', () => phoneInput.setCustomValidity(''));
    updateCode();
  }
  const subscriberKey = 'kb-collector-subscribed';
  const inlineInvitations = document.querySelectorAll('[data-collector-invitation-trigger]');
  const inlineButtons = document.querySelectorAll('[data-collector-open]');
  let subscribed = card.dataset.knownSubscriber === 'true';
  const remember = () => {
    subscribed = true;
    inlineInvitations.forEach((invitation) => { invitation.hidden = true; });
    try { localStorage.setItem(subscriberKey, '1'); } catch { /* Storage is optional. */ }
  };
  try { subscribed ||= localStorage.getItem(subscriberKey) === '1'; } catch { /* Account recognition remains available. */ }
  if (subscribed && !demo) return;
  const enabled = card.dataset.enabled === 'true' && !['localhost', '127.0.0.1'].includes(location.hostname);
  const announce = (message) => { status.hidden = false; status.textContent = message; };
  if (!enabled) announce('Design preview only. No information will be sent.');
  let elapsed = false;
  let dismissed = false;
  const shownKey = 'kb-collector-invitation-shown';
  try { dismissed = !demo && sessionStorage.getItem(shownKey) === '1'; } catch { /* Storage is optional. */ }
  if (dismissed) teaser.hidden = false;
  let pending = false;
  let completed = false;
  let widget;
  let scriptPromise;
  let returnFocus;
  const open = () => {
    if (!demo) {
      try { sessionStorage.setItem(shownKey, '1'); } catch { /* Keep signup usable without storage. */ }
    }
    card.hidden = false;
    teaser.hidden = true;
    teaser.setAttribute('aria-expanded', 'true');
    inlineButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
  };
  const dismiss = () => {
    dismissed = true;
    card.hidden = true;
    teaser.hidden = completed;
    teaser.setAttribute('aria-expanded', 'false');
    inlineButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (!completed) (returnFocus || teaser).focus();
    returnFocus = undefined;
  };
  const reveal = () => {
    if (dismissed || !elapsed || completed) return;
    if (document.querySelector('dialog[open]')) { setTimeout(reveal, 500); return; }
    open();
  };
  const activityEvents = ['pointermove', 'pointerdown', 'scroll', 'keydown'];
  const startCountdown = () => {
    activityEvents.forEach((type) => window.removeEventListener(type, startCountdown));
    setTimeout(() => { elapsed = true; reveal(); }, 3000);
  };
  activityEvents.forEach((type) => window.addEventListener(type, startCountdown, { passive: true }));
  teaser.addEventListener('click', () => { open(); form.querySelector('[name="name"]').focus(); });
  inlineInvitations.forEach((invitation) => { invitation.hidden = false; });
  inlineButtons.forEach((button) => button.addEventListener('click', () => {
    returnFocus = button;
    open();
    form.querySelector('[name="name"]').focus();
  }));
  card.querySelector('.collector-invitation__close').addEventListener('click', dismiss);
  card.addEventListener('keydown', (event) => { if (event.key === 'Escape') dismiss(); });
  window.addEventListener('storage', (event) => {
    if (event.key === subscriberKey && event.newValue === '1' && !demo) {
      completed = true;
      card.hidden = true;
      teaser.hidden = true;
      inlineInvitations.forEach((invitation) => { invitation.hidden = true; });
    }
  });

  const loadSecurity = () => {
    if (window.turnstile) return Promise.resolve();
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => reject(new Error('The security check could not load. Please reload and try again.')), 15000);
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => { clearTimeout(timer); resolve(); };
      script.onerror = () => { clearTimeout(timer); reject(new Error('The security check could not load. Please reload and try again.')); };
      document.head.append(script);
    });
    return scriptPromise;
  };
  const securityToken = async () => {
    await loadSecurity();
    if (widget !== undefined) window.turnstile.remove(widget);
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('The security check timed out. Please try again.')), 120000);
      const fail = () => { clearTimeout(timer); reject(new Error('The security check could not finish. Please try again.')); };
      widget = window.turnstile.render(card.querySelector('[data-signup-challenge]'), {
        sitekey: card.dataset.sitekey, action: 'collector_signup', appearance: 'interaction-only', size: 'flexible',
        callback: (token) => { clearTimeout(timer); resolve(token); },
        'error-callback': fail, 'expired-callback': fail, 'timeout-callback': fail,
      });
    });
  };
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || completed) return;
    let phone;
    try {
      if (!window.KBCollectorPhone && phoneInput.value.trim()) throw new Error('Please reload to load the country codes, or leave the phone number blank.');
      phone = phoneInput.value.trim() ? KBCollectorPhone.normalize(phoneInput.value, phoneCountry.value) : '';
    } catch (error) {
      phoneInput.setCustomValidity(error.message);
      phoneInput.reportValidity();
      return;
    }
    if (!enabled) { announce('Preview complete. Nothing was sent or saved.'); return; }
    pending = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    label.textContent = 'Signing you up…';
    status.hidden = true;
    const values = new FormData(form);
    try {
      const token = await securityToken();
      const response = await fetch(card.dataset.endpoint, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal: AbortSignal.timeout(45000),
        body: JSON.stringify({ name: values.get('name'), email: values.get('email'), phone, emailConsent: true, token }),
      });
      if (!(response.headers.get('content-type') || '').includes('application/json')) {
        throw new Error('The signup service could not confirm your details (HTTP ' + response.status + '). Please try again shortly.');
      }
      const result = await response.json();
      if (!response.ok || result.ok !== true) throw new Error(result.message || 'We could not complete your signup. Please try again.');
      remember();
      completed = true;
      form.hidden = true;
      announce('Thank you for joining us.');
      status.focus();
      card.querySelector('.collector-invitation__close').setAttribute('aria-label', 'Close signup');
    } catch (error) {
      announce(error instanceof SyntaxError || error.name === 'TimeoutError' || error.name === 'TypeError'
        ? 'Signup is temporarily unavailable. Your details have not been confirmed. Please try again.' : error.message);
      status.focus();
    } finally {
      pending = false;
      submit.disabled = false;
      form.removeAttribute('aria-busy');
      label.textContent = 'Sign me up';
      if (widget !== undefined) { window.turnstile.remove(widget); widget = undefined; }
    }
  });
})();
